import React, { useEffect, useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import LineChats from './LineChats';
import Skeleton from 'react-loading-skeleton';
import TableData from './TableData';
import ReportGenerate from '../layout/ReportGenerate';
import MultiBarChats from './MultiBarChats';
import ExportDayWise from '../layout/ExportDayWise';
import Exportuserwise from '../layout/Exportuserwise';

const MyDateRangePicker = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const handleSelect = (ranges) => {
    setStartDate(ranges.selection.startDate);
    setEndDate(ranges.selection.endDate);
  };
  // const formatDate = (date) => {
  //   console.log(date)
  //   const year = date.getFullYear();
  //   const month = String(date.getMonth() + 1).padStart(2, '0'); // Add 1 because getMonth() is zero-based
  //   const day = String(date.getDate()).padStart(2, '0');
  //   console.log(year-month-day)
  //   return `2024-11-10`;
  // };


  const formatDateToISO = (dateString) => {
    // Convert the input string to a Date object
    const date = new Date(dateString);
  
    // // Check if the date is valid
    // if (isNaN(date)) {
    //   throw new Error(`Invalid date: ${dateString}`);
    // }
  
    // Extract year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const day = String(date.getDate()).padStart(2, '0');
  
    // Return in YYYY-MM-DD format
    return `${year}-${month}-${day}`;
  }
  
  // Example usage
  // const inputDate = "Fri Nov 22 2024 04:16:25 GMT+0000 (Coordinated Universal Time)";
  // const formattedDate = formatDateToISO(inputDate)
  
  const baseurlFaqs = `${process.env.REACT_APP_SERVER_URL}/aipd/completeTrackingTimed?start=${startDate.toLocaleDateString('en-US')}&end=${endDate.toLocaleDateString('en-US')}`;
  const baseurlByDate = `${process.env.REACT_APP_SERVER_URL}/aipd/viewsPerReportByPersonaWithTime?startDate=${formatDateToISO(startDate)}&endDate=${formatDateToISO(endDate)}`;
  const baseurluserByDate = `${process.env.REACT_APP_SERVER_URL}/aipd/getUserWiseReportViewPerPersona?startDate=${formatDateToISO(startDate)}&endDate=${formatDateToISO(endDate)}`;

  const [dataItems, setData] = useState();
  const [dateWiseItems, setDateWise] = useState();
  const [dateuserwiseItems, setDateuserwiseItems] = useState();

  const [DataLoading, setDataLoading] = useState(true);
  const [DataLoading1, setDataLoading1] = useState(true);
  const [DataLoading2, setDataLoading2] = useState(true);

  const [isLoading, setisLoading] = useState(true);
  const [isLoading1, setisLoading1] = useState(true);
  const [isLoading2, setisLoading2] = useState(true);


  const passtoken = JSON.parse(localStorage.getItem("access-token-storage"))["accessToken"];

  useEffect(() => {
    setisLoading(true)
    setisLoading1(true)
    setDataLoading1(true)
    const GetFaqsLsit = async () => {
      try {
        const response = await fetch(baseurlFaqs, {
          headers: {
            Accept: "application/json",
            "oidc-token": passtoken,
          },
        });

        if (response.ok) {
          const jsonData = await response.json();
          // console.log(jsonData);
          setData(...jsonData);
          setDataLoading(false)
          setisLoading(false);
        } else {
          setData([]);
          setisLoading(false);
          
        }
      } catch (err) {
        console.error("Error:", err);
        setisLoading(false);
        setData([]);
      }
    };

    const GetViewsByDate = async () => {
      try {
        const response = await fetch(baseurlByDate, {
          headers: {
            Accept: "application/json",
            "oidc-token": passtoken,
          },
        });

        if (response.ok) {
          const jsonData = await response.json();
          console.log("jsonData");
          console.log(jsonData);

          setDateWise(jsonData);
          setDataLoading1(false)
          setisLoading1(false);
        } else {
          setDateWise([]);
          setisLoading1(false);
          
        }
      } catch (err) {
        console.error("Error:", err);
        setisLoading1(false);
        setDateWise([]);
      }
    };

    const GetViewsByuser = async () => {
      try {
        const response = await fetch(baseurluserByDate, {
          headers: {
            Accept: "application/json",
            "oidc-token": passtoken,
          },
        });

        if (response.ok) {
          const jsonData = await response.json();
          console.log(jsonData);
          setDateuserwiseItems(jsonData);
          setDataLoading2(false)
          setisLoading2(false);
        } else {
          setDateuserwiseItems([]);
          setisLoading2(false);
          
        }
      } catch (err) {
        console.error("Error:", err);
        setisLoading2(false);
        setDateuserwiseItems([]);
      }
    };
    GetFaqsLsit();
    GetViewsByDate();
    GetViewsByuser();
  }, [passtoken, baseurlFaqs,baseurlByDate,baseurluserByDate]);

  console.log("dateuserwiseItems",dateuserwiseItems)
  return (
    <div style={{ display: "grid",gridGap:"1rem" }}>
    
      <div style={{ display: "flex", gridGap: "1rem" }}>
        <div id="datepickerID">
          <DateRangePicker
            ranges={[
              {
                startDate,
                endDate,
                key: "selection",
              },
            ]}
            onChange={handleSelect}
          />
          {/* <p>Start Date: {startDate && startDate.toLocaleDateString("en-US")}</p>
      <p>End Date: {endDate && endDate.toLocaleDateString("en-US")}</p> */}
        </div>

        <div style={{ width: "100%" }}>
          {/* <TableData dataLoading={DataLoading} data={dataItems} /> */}

          {isLoading && (
            <div>
              <Skeleton height="400px" />
              {/* <span style={{ paddingTop: "10px", display: "block" }}>
                      Thank you for your patience! We're in the process of gathering
                      the data needed to create your graph
                    </span> */}
            </div>
          )}

          {!isLoading && (
            <div
              style={{
                border: "1px solid #eee",
                display: "flex",
                width: "100%",
                padding: "1rem",
                borderRadius: "6px",
                position:"relative",
                gap:"10px",
                justifyContent:"flex-end"
              }}
            >
               <div>
                  <ExportDayWise
                    excelData={dateWiseItems}
                    fileName={`Fullreport_${new Date().getTime()}`}
                    title = "Generate full reports"

                  />
                </div>
              {/* <LineChats dataLoading={DataLoading} jsonData={dataItems} /> */}
              {/* <BarChats  dataLoading={DataLoading} data={dataItems}/> */}

              <div>
                  <Exportuserwise
                    excelData={dateuserwiseItems}
                    fileName={`userwise_${new Date().getTime()}`}
                    title = "Generate report user wise "
                  />
                </div>
            </div>
          )}
        </div>
      </div>

      <div>
        {isLoading && (
          <div>
            <Skeleton height="400px" />
            {/* <span style={{ paddingTop: "10px", display: "block" }}>
              Thank you for your patience! We're in the process of gathering the
              data needed to create your graph
            </span> */}
          </div>
        )}

        {!isLoading && (
          <div
            style={{
              display: "grid",
              width: "100%",
              borderRadius: "6px",
            }}
          >
            {/* <TableData dataLoading={DataLoading} data={dataItems} /> */}
            {!isLoading1 && (
              <div>
                
                {/* <div style={{position:"absolute",right:"10px",top:"10px"}}>
                  <ReportGenerate
                    excelData={dateWiseItems}
                    fileName={`Fullreport_${new Date().getTime()}`}
                  />
                </div> */}
                <MultiBarChats dataLoading={DataLoading1} dataItems={dateWiseItems}/>

              </div>

            )}

            
            </div>
        )}
      </div>
    </div>
  );
};

export default MyDateRangePicker;
